import { DriverMeWithInfoOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryErrorHandler, silentQueryErrorHandler } from '../services/datastore/react-query';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchUser = () => driverApi.get<void, DriverMeWithInfoOutput>('/v1/driver/me');

export const useFetchUser = (
  options: QueryOptions<typeof queryKeys.user.me, DriverMeWithInfoOutput> = {},
  silent = true,
) =>
  useQuery(queryKeys.user.me(), fetchUser, {
    staleTime: Infinity,
    cacheTime: Infinity,
    onError: silent ? silentQueryErrorHandler : queryErrorHandler,
    ...options,
  });
